Backbone.Radio.channel('views').reply('form-paymentmethod',function(options){
	var opts = {
		 type:"CREDITCARD"
		,allowCheck:false
		,donationType:""
		,premiumLimited:false
	}
	
	var radio = Backbone.Radio.channel('pledgeform')
	
	/*
	 *	Trigger	
	 *		Events
	 */
	var triggerUpdated = function(){
		radio.trigger("paymentMethod:updated",{
			 type:opts.type
		})
	}	

	var view = Marionette.View.extend({
		 template:_.template($("#tmpl-form-paymentmethod").html())
		,model:options.model
		,templateContext:function(){
			var payment_method;
			/* public form doesn't have a model, so fake the payment methods so the template doesn't break */
			if(typeof this.model==="undefined"){
				payment_method=[];
			}else{
				payment_method=this.model.attributes.payment_method;
			}
			return {
				payment_method:payment_method
			}
		}
		,events:{
			'change #selectPaymentType':function(e){
				opts.type = $(e.currentTarget).val();
				this.updateType();
			}
			,'blur.error #ccNum, #bankId, #bankAcct':function(e){
				var $this = $(e.currentTarget),
				    id = $this.attr('id');
		
				if( !$this.val().length ){
					$this.addClass('error'); 
					this.$el.find('#error-'+id).show() 
				}else{
					$this.removeClass('error'); 
					this.$el.find('#error-'+id).hide() 
				}
				
				if(!Backbone.settings.flags.callcenter){	
					if( id == 'ccNum' && !Backbone.Radio.channel('utilities').request('creditCardValidate',{'ccNum':$this.val()}) ){ $this.addClass('error'); this.$el.find('#error-ccNum').show()  }
				}
			}
		}
		,onAttach:function(){
			var that = this;
			
			radio.on("donation:updated",function(data){
				opts.donationType= data.type;
				
				that.updateAllowCheck()	
				that.updateAvailable()	
			});
			
			radio.on("premiums:updated",function(data){
				opts.premiumLimited= data.limited;
				opts.premiumCategory = data.category;
				
				if(data.limited){
					$('#paymentTypeAlert').empty().append("<span class='font-bold'>Due to the limited quantities available for the gift selected, only credit card and EFT are available as payment types.</span>").show()
				}else{
					$('#paymentTypeAlert').hide()
				}

				that.updateAllowCheck()	
				that.updateAvailable()	
			});
			// Trigger change to ensure type is set correctly when we are using pre-existing payment methods #170752686
			this.$el.find('#selectPaymentType').trigger('change')
		}
		,updateType:function(){
			if( opts.type == 'EFT' ){ 
				this.$el.find('#ccInfo').slideUp() 
				this.$el.find('#eftInfo').slideDown() 
			}else if( opts.type ==  'CREDITCARD'){
				this.$el.find('#eftInfo').slideUp() 
				this.$el.find('#ccInfo').slideDown()				
			}else{ //check or existing payment method selected
				this.$el.find('#eftInfo').slideUp() 
				this.$el.find('#ccInfo').slideUp() 
			}
			
			triggerUpdated();
		}
		,updateAllowCheck:function(){
			if(opts.premiumLimited===true || opts.donationType==="sustainer" || opts.premiumCategory==="Tickets"){
				opts.allowCheck = false;
			}else{
				opts.allowCheck = true;
			}
		}
		,updateAvailable:function(){
			var sel = this.$el.find('#selectPaymentType');
	
			if(!opts.allowCheck && sel.children('option[value=SendBill]').length ){
				sel.children('option[value=SendBill]').remove()
				sel.children('option:first-child').attr('selected','selected').end().trigger('change');
			}else if(opts.allowCheck && !sel.children('option[value=SendBill]').length ){
				sel.append( $('<option value="SendBill">Check (we will mail you a reminder)</option>') )
			}
		}
	})
	
	
	return new (view)();
});